import {createApp} from 'vue'
import {createPinia} from 'pinia'
import {createRouter, createWebHashHistory} from 'vue-router'

import jQuery from 'jquery'
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'bootstrap'

import './css/custom.scss'
import 'bootstrap/scss/bootstrap.scss'

import './js/codemirror'
import './styles'

import {useFormStore} from '@/stores/form'
import {useModalsStore} from '@/stores/modals'
import focus from './vue/directives/focus'
import select from './vue/directives/select'
import Dump from './vue/common/Dump'
import Picture from './vue/common/Picture'

import Dashboard from './components/dashboard/Dashboard'
import ComponentRoot from './components/component-root/ComponentRoot'
import ComponentSettings from './components/component-settings/ComponentSettings'
import ComponentFields from './components/component-fields/ComponentFields'
import Form from './components/form/Form'
import List from './components/List'
import PageEditor from './components/page-editor/PageEditor'
import Reports from './components/reports/Reports'
import SalesReports from './components/SalesReports'
import Settings from './components/Settings'
import SiteTreePanes from './components/site-tree-panes/SiteTreePanes'
import SubscriptionPlan from './components/subscription-plan/SubscriptionPlan'
import ThemesEditor from './components/themes-editor/ThemesEditor'
import App from './App'

////////// Create App Instance //////////

const app = createApp(App)

////////// Global Directives & Components //////////

app.directive('focus', focus)
app.directive('select', select)

app.component('Dump', Dump)
app.component('Picture', Picture)

////////// Plugins //////////

const pinia = createPinia()
app.use(pinia)

////////// Vue Router Setup //////////

const router = createRouter({
    history: createWebHashHistory(), // or createWebHashHistory() if using hash mode
    routes: [
        {
            name: 'dashboard',
            path: '/',
            component: Dashboard
        },
        {
            name: 'salesReports',
            path: '/sales-reports',
            component: SalesReports
        },
        {
            name: 'settings',
            path: '/settings',
            component: Settings
        },
        {
            path: '/subscription-plan',
            component: SubscriptionPlan
        },
        {
            name: 'reports',
            path: '/reports',
            component: Reports
        },
        {
            name: 'siteTree',
            path: '/site_tree/:pageOrContentId?',
            component: SiteTreePanes
        },
        {
            name: 'pageEditor',
            path: '/editor/:pageId?/:sectionId?/:areaIndex?/:pageContentId?',
            component: PageEditor
        },
        {
            name: 'themesEditor',
            path: '/themes_editor',
            component: ThemesEditor
        },
        {
            name: 'componentRoot',
            path: '/:component',
            component: ComponentRoot,
            children: [
                {
                    name: 'list',
                    path: '',
                    component: List
                },
                {
                    name: 'componentSettings',
                    path: 'settings',
                    component: ComponentSettings,
                    meta: {
                        breadcrumb: 'Settings'
                    }
                },
                {
                    name: 'componentFields',
                    path: 'fields/:fieldsetId?/:fieldId?',
                    component: ComponentFields,
                    meta: {
                        breadcrumb: 'Attributes'
                    }
                },
                {
                    name: 'form',
                    path: ':id',
                    component: Form,
                },
            ]
        },
        {
            name: 'pageContent',
            path: '/pages/:pageId/:pageContentId',
            component: Form,
        }
    ]
})

router.beforeEach((to, from, next) => {
    let formId
    if (from.name === 'form') {
        formId = 'form:' + from.params.component + ':' + from.params.id
    } else if (from.name === 'settings') {
        formId = 'form:account_settings:1'
    }
    
    // Unsaved form changes confirmation modal
    if (formId) {
        const formStore = useFormStore(formId)
        const isModified = formStore.isModified
        if (isModified) {
            const modalsStore = useModalsStore(pinia)
            modalsStore.show({
                componentName: 'ConfirmModal',
                obj: {
                    modalTitle: 'Are you sure?',
                    modalBody: `
                        <p class="alert alert-danger">
                            Your unsaved changes will be lost.
                        </p>
                    `,
                    onConfirm: () => {
                        next()
                    }
                }
            })
            return
        }
    }
    
    next()
})

app.use(router)

////////// Mount App //////////

app.mount('#app')